import { Link } from 'react-router-dom';
import { featuredComics } from '@/mocks/comics';

export default function FeatureGrid() {
  return (
    <section id="featured" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <div className="mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            热门推荐
          </h2>
          <p className="mt-2 text-sm text-foreground-600">精选优质韩漫，从这里开始你的阅读之旅</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {featuredComics.map((comic, index) => (
            <Link
              key={comic.slug}
              to="/"
              className={`group relative rounded-xl overflow-hidden cursor-pointer ${
                index === 0 ? 'md:col-span-1 md:row-span-1' : ''
              }`}
            >
              <div className={`relative w-full ${index === 0 ? 'h-[500px] md:h-[560px]' : 'h-[400px] md:h-[440px]'}`}>
                <img
                  src={comic.coverImage}
                  alt={comic.title}
                  title={comic.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/20 to-transparent"></div>

                <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                  <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-500 text-white mb-3">
                    {comic.category}
                  </span>
                  <h3 className="text-lg md:text-xl font-heading font-bold text-white mb-1">
                    {comic.title}
                  </h3>
                  <p className="text-sm text-white/80 line-clamp-2 mb-2">
                    {comic.description}
                  </p>
                  <div className="flex items-center gap-3 text-xs text-white/70">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {comic.totalViews}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-star-fill text-accent-500"></i>
                      {comic.rating}
                    </span>
                    <span>{comic.status}</span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}